(() => {
  if (window.__bpcCardPriceLayoutLoaded) return;
  window.__bpcCardPriceLayoutLoaded = true;

  let queued = false;
  let rendering = false;

  const isCardPrice = (root) => {
    if (!root || root.classList.contains('price--large')) return false;
    if (root.closest('.cart-item,#CartDrawer,cart-drawer,cart-items,.drawer,.bpc-currency-modal,.unit-price')) return false;
    return Boolean(root.closest('.card-wrapper,.card-information,.product-card-wrapper,.complementary-slide,.predictive-search__result-group,.search-modal'));
  };

  const getCents = (item) => {
    const stored = Number(item.dataset.bpcCardUsdCents);
    if (Number.isFinite(stored) && stored >= 0) return Math.round(stored);

    const raw = item.dataset.bpcUsdCents;
    if (raw == null || String(raw).trim() === '') return null;

    const source = Number(raw);
    if (!Number.isFinite(source) || source < 0) return null;

    const cents = Math.round(source);
    item.dataset.bpcCardUsdCents = String(cents);
    return cents;
  };

  const restoreUsd = (item, engine) => {
    const cents = getCents(item);
    if (!Number.isFinite(cents)) return null;

    const from = item.dataset.bpcPriceFrom === 'true';
    const text = `${from ? 'From ' : ''}${engine.formatUsd(cents / 100)}`;

    item.removeAttribute('data-bpc-usd-cents');
    item.removeAttribute('data-bpc-fx-key');
    if (item.textContent.trim() !== text) item.textContent = text;

    return cents;
  };

  const renderCardPrice = (root, engine) => {
    if (!isCardPrice(root)) return;

    root.querySelectorAll('.price-item[data-bpc-usd-cents],.price-item[data-bpc-card-usd-cents]').forEach((item) => {
      restoreUsd(item, engine);
    });

    const visible = root.classList.contains('price--on-sale')
      ? root.querySelector('.price__sale .price-item--sale')
      : root.querySelector('.price__regular .price-item--regular');

    if (!visible) return;

    const cents = Number(visible.dataset.bpcCardUsdCents);
    if (!Number.isFinite(cents) || cents < 0) return;

    const localValue = engine.toLocal(cents / 100);
    if (!Number.isFinite(localValue) || localValue <= 0) return;

    const from = visible.dataset.bpcPriceFrom === 'true';
    const text = `(approx. ${from ? 'from ' : ''}${engine.formatLocal(localValue)})`;
    const key = `${cents}:${engine.rate}:${engine.buffer}:${engine.currency}:${from ? 'from' : 'fixed'}`;

    let local = root.querySelector(':scope > .bpc-card-local-estimate');
    if (!local) {
      local = document.createElement('span');
      local.className = 'bpc-card-local-estimate';
      local.setAttribute('data-nosnippet', '');
      const container = root.querySelector(':scope > .price__container');
      if (container) container.insertAdjacentElement('afterend', local);
      else root.appendChild(local);
    }

    if (local.dataset.bpcCardFxKey !== key || local.textContent !== text) {
      local.textContent = text;
      local.dataset.bpcCardFxKey = key;
    }

    root.setAttribute(
      'aria-label',
      `${engine.formatUsd(cents / 100)}; approximately ${engine.formatLocal(localValue)} in local currency`
    );
  };

  const render = () => {
    queued = false;
    if (rendering) return;

    const engine = window.BpcCurrency;
    if (!engine || engine.currency === 'USD') return;

    rendering = true;
    document.querySelectorAll('.price').forEach((root) => renderCardPrice(root, engine));
    rendering = false;
  };

  const schedule = () => {
    if (queued || rendering) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(render));
  };

  document.addEventListener('bpc:currency-ready', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  if (window.BpcCurrency) schedule();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
